var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgConexaoCertificadaSebraeLogoTexto = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113.203,
    height: 34.65,
    viewBox: "0 0 113.203 34.65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ccsa{fill:#006ec7;}.cssb,.ccsc{isolation:isolate;}.ccsd{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.666,
    y1: -18.212,
    x2: 15.495,
    y2: -18.212,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006ec7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -273.275)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M107.931,281.468c.059-.613-.328-.841-.807-.841-1.018,0-1.522.934-1.758,2.044-.084.37-.395,1.9.909,1.9a1.178,1.178,0,0,0,1.2-.882h1.749c-.412,1.9-2.38,2.06-3.17,2.06a2.669,2.669,0,0,1-2.136-.807,2.954,2.954,0,0,1-.286-2.3,4.268,4.268,0,0,1,1.253-2.312,3.466,3.466,0,0,1,2.5-.892,2.412,2.412,0,0,1,2.052.74,1.594,1.594,0,0,1,.227,1.295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M111.229,280.232a4.1,4.1,0,0,1,2.557-.841c2.422,0,2.708,1.741,2.388,3.221a3.767,3.767,0,0,1-3.834,3.162c-1.615,0-2.927-.891-2.448-3.154A4.448,4.448,0,0,1,111.229,280.232Zm1.4,4.306c1.2,0,1.64-1.11,1.817-1.951a2.317,2.317,0,0,0-.059-1.539.96.96,0,0,0-.917-.437c-1.11,0-1.614.958-1.841,2C111.423,283.579,111.507,284.538,112.625,284.538Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M117.69,279.559h2.321l1.093,4.525.942-4.525h1.471l-1.286,6.072H119.96l-1.093-4.718-.984,4.718H116.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M124.629,279.576h4.558l-.244,1.161H126.05L125.781,282h2.725l-.252,1.161h-2.725l-.269,1.3h2.96l-.252,1.177h-4.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M130.324,285.631h-1.968l2.977-3.162-1.523-2.91h2.17l.791,1.884,1.623-1.884h1.934l-2.767,2.876,1.59,3.2H133l-.866-2.161Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M138.962,279.559h2.052l1.11,6.072h-1.9l-.159-1.219h-2.431l-.672,1.219h-1.682Zm-.791-.664a1.74,1.74,0,0,1,.539-.849,1.433,1.433,0,0,1,.95-.379,1.8,1.8,0,0,1,.589.118l.613.185a.694.694,0,0,0,.244.05c.244,0,.328-.243.353-.327h.682a1.658,1.658,0,0,1-1.438,1.21,1.46,1.46,0,0,1-.4-.075l-.647-.2a1.026,1.026,0,0,0-.345-.067.536.536,0,0,0-.48.336Zm1.741,4.4-.244-2.548h-.025l-1.379,2.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M144.11,280.232a4.1,4.1,0,0,1,2.557-.841c2.422,0,2.707,1.741,2.388,3.221a3.767,3.767,0,0,1-3.835,3.162c-1.614,0-2.926-.891-2.447-3.154A4.447,4.447,0,0,1,144.11,280.232Zm1.4,4.306c1.2,0,1.64-1.11,1.817-1.951a2.323,2.323,0,0,0-.059-1.539.96.96,0,0,0-.917-.437c-1.11,0-1.615.958-1.842,2C144.3,283.579,144.388,284.538,145.506,284.538Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M107.931,290.216c.059-.613-.328-.841-.807-.841-1.018,0-1.522.934-1.758,2.044-.084.37-.395,1.9.909,1.9a1.178,1.178,0,0,0,1.2-.883h1.749c-.412,1.9-2.38,2.061-3.17,2.061a2.667,2.667,0,0,1-2.136-.808,2.951,2.951,0,0,1-.286-2.3,4.268,4.268,0,0,1,1.253-2.312,3.466,3.466,0,0,1,2.5-.892,2.412,2.412,0,0,1,2.052.74,1.594,1.594,0,0,1,.227,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M110.952,288.324h4.558l-.244,1.161h-2.893l-.269,1.261h2.725l-.253,1.161h-2.724l-.27,1.295h2.961l-.252,1.177h-4.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M116.444,288.307h2.809c1.094,0,1.5.068,1.775.438a1.32,1.32,0,0,1,.176,1.177,1.519,1.519,0,0,1-.8,1.127,2.633,2.633,0,0,1-.992.311l-.008.034c1.177.033,1.127.555,1.068,1.488a8.875,8.875,0,0,0-.034,1.5h-1.825a8.625,8.625,0,0,1,.093-1.371c.076-.731.109-1-.648-1h-.706l-.5,2.371h-1.69Zm1.144,2.607h.631a2.437,2.437,0,0,0,.706-.05.906.906,0,0,0,.589-.69c.16-.748-.5-.748-.984-.748H117.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M123.569,289.51h-1.85l.252-1.2h5.441l-.252,1.2h-1.892l-1.035,4.869h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M127.918,288.307h1.732l-1.287,6.072h-1.732Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M130.727,288.324h4.3l-.252,1.169h-2.624l-.294,1.413h2.439l-.252,1.169H131.6l-.488,2.3h-1.673Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M135.69,288.307h1.732l-1.286,6.072H134.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M141.922,290.216c.059-.613-.328-.841-.807-.841-1.018,0-1.523.934-1.758,2.044-.084.37-.395,1.9.908,1.9a1.178,1.178,0,0,0,1.2-.883h1.749c-.412,1.9-2.38,2.061-3.17,2.061a2.666,2.666,0,0,1-2.136-.808,2.947,2.947,0,0,1-.286-2.3,4.255,4.255,0,0,1,1.253-2.312,3.462,3.462,0,0,1,2.5-.892,2.412,2.412,0,0,1,2.052.74,1.59,1.59,0,0,1,.227,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M146.658,288.307h2.052l1.11,6.072h-1.9l-.16-1.219h-2.431l-.673,1.219h-1.681Zm.95,3.734-.243-2.548h-.026l-1.379,2.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M151.731,288.307H154.3a3.815,3.815,0,0,1,2.211.505,2.42,2.42,0,0,1,.606,2.514,3.456,3.456,0,0,1-2.254,2.818,5.631,5.631,0,0,1-1.833.235h-2.582Zm.689,4.9h.724a2.088,2.088,0,0,0,2.236-1.9c.387-1.842-.992-1.842-1.505-1.842l-.664-.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M160.041,288.307h2.052l1.11,6.072h-1.9l-.159-1.219h-2.431l-.673,1.219h-1.681Zm.95,3.734-.244-2.548h-.025l-1.379,2.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M105.965,302.851c-.057.332-.24,1.281,1.121,1.281.194,0,1.224,0,1.43-.937.08-.389-.023-.653-.549-.8l-1.91-.526a1.8,1.8,0,0,1-1.568-2.265c.286-1.339,1.556-2.585,4.027-2.585,3.226,0,3,1.75,2.813,2.631h-2.322c.058-.252.264-1.144-.834-1.144a1.221,1.221,0,0,0-1.27.869c-.137.606.332.755.652.846l1.452.4c1.041.286,2.277.629,1.9,2.379-.388,1.841-2.139,2.665-4.209,2.665-.858,0-2.219-.137-2.791-.984a2.345,2.345,0,0,1-.24-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M113.309,297.246h6.2l-.332,1.579h-3.935l-.366,1.716h3.706l-.343,1.578h-3.706l-.366,1.762h4.026l-.343,1.6h-6.291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M120.734,297.224h3.305c1.041,0,2.1,0,2.723.674a1.578,1.578,0,0,1,.332,1.419,2.592,2.592,0,0,1-2.163,1.876l-.011.023c.5.091,1.922.354,1.556,2.047a2.652,2.652,0,0,1-1.545,1.876,5.318,5.318,0,0,1-2.3.343h-3.648Zm.8,6.748h1.27a1.262,1.262,0,0,0,1.384-.961c.206-.995-.732-.995-1.041-.995h-1.2Zm.721-3.42h1.075a1.9,1.9,0,0,0,.824-.1,1.166,1.166,0,0,0,.594-.8.764.764,0,0,0-.16-.732.923.923,0,0,0-.7-.2h-1.247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M128.924,297.224h3.821c1.487,0,2.036.091,2.413.6a1.794,1.794,0,0,1,.241,1.6,2.063,2.063,0,0,1-1.087,1.532,3.6,3.6,0,0,1-1.35.424l-.011.046c1.6.045,1.532.754,1.452,2.024a12.1,12.1,0,0,0-.045,2.036h-2.482a11.615,11.615,0,0,1,.125-1.864c.1-1,.149-1.361-.88-1.361h-.961l-.687,3.225h-2.3Zm1.556,3.545h.858a3.322,3.322,0,0,0,.961-.068,1.237,1.237,0,0,0,.8-.938c.217-1.018-.675-1.018-1.339-1.018H130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M139.677,297.224h2.791l1.51,8.258h-2.585l-.217-1.658H137.87l-.915,1.658h-2.288Zm1.293,5.078-.332-3.466H140.6l-1.876,3.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M146.529,297.246h6.2l-.332,1.579h-3.934l-.366,1.716H151.8l-.343,1.578h-3.707l-.366,1.762h4.027l-.343,1.6h-6.292Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ccsb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M58.9,307.925a4.49,4.49,0,0,1-3.182-1.318,19.525,19.525,0,1,1,27.612-27.613l7.4,7.4a4.5,4.5,0,0,1-6.365,6.365l-7.4-7.4a10.523,10.523,0,0,0-14.882,14.882,4.5,4.5,0,0,1-3.183,7.684Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ccsc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M58.9,307.925a4.49,4.49,0,0,1-3.182-1.318,19.525,19.525,0,1,1,27.612-27.613l7.4,7.4a4.5,4.5,0,0,1-6.365,6.365l-7.4-7.4a10.523,10.523,0,0,0-14.882,14.882,4.5,4.5,0,0,1-3.183,7.684Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ccsd",
    d: "M66.118,296.825a5.131,5.131,0,0,0,7.257,0l17.573-17.574a5.131,5.131,0,1,1,7.257,7.257L80.631,304.081a5.13,5.13,0,0,1-7.256,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccsa",
    d: "M73.375,289.568a5.131,5.131,0,1,0,0,7.257L77,293.2Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConexaoCertificadaSebraeLogoTexto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/conexao-certificada-sebrae-logo-texto.0479ad0c.svg";
export { ForwardRef as ReactComponent };